import { Formik } from "formik";
import { Box, Checkbox, FormControlLabel } from "@mui/material";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import {
	colorPaletteBlue600,
	textNeutralTertiary,
} from "../../core/theme";
import Modal from "../components/Modal";
import FluidDatePicker from "../components/FluidDatePicker";
import { Spacer } from "../components/Spacer";
import { PrimaryButton } from "../components/CustomButton";
const style = {
	container: {
		width: "580px",
		paddingLeft: "24px",
		paddingRight: "24px",
		paddingBottom: "24px",
	},
	titleIcon: {
		color: colorPaletteBlue600,
	},
	description: {
		color: textNeutralTertiary,
		fontSize: 20,
		fontWeight: 400,
		fontFamily: "Lato",
	},
	inputsContainer: {
		gap: "40px",
		display: "flex",
	},
};

export interface GenerateCurtailmentObjectsFromSiteProps {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: ({
		startDate,
		endDate,
		create_ch51,
        fix_overlapping_horizons
	}: {
		startDate: string;
		endDate: string;
		create_ch51: string;
        fix_overlapping_horizons: string;
	}) => void;
}

export const GenerateCurtailmentObjectsFromSite = ({
	isOpen,
	onClose,
	onSubmit,
}: GenerateCurtailmentObjectsFromSiteProps) => {
	return (
		<Formik
			enableReinitialize
			initialValues={{
				startDate: "",
				endDate: "",
				create_ch51: true,
                fix_overlapping_horizons: false,
			}}
			onSubmit={({ startDate, endDate, create_ch51,fix_overlapping_horizons }) =>
				onSubmit({
					startDate,
					endDate,
					create_ch51: create_ch51 ? "True" : "False",
                    fix_overlapping_horizons: fix_overlapping_horizons ? "True" : "False",
				})
			}
		>
			{({ handleChange, submitForm, resetForm, values, setFieldValue }) => (
				<Modal
					open={isOpen}
					onClose={onClose}
					title={"Generate Curtailment Objects"}
					sx={style.container}
					icon={
						<span style={style.titleIcon}>
							<AddCircleOutlineOutlinedIcon />
						</span>
					}
					actions={
						<>
							<PrimaryButton
								onClick={() => {
									onClose();
									resetForm();
								}}
								text="Cancel"
								type="button"
								color="secondary"
							/>
							<PrimaryButton
								onClick={() => {
									submitForm();
								}}
								text="Generate"
								type="button"
								color="primary"
								startIcon={<AddCircleOutlineOutlinedIcon />}
							/>
						</>
					}
				>
					<Box sx={style.description}>
						Please specify the start and end dates for the period
						you want to generate curtailment objects.
					</Box>
					<Spacer gap={32} />
					<Box sx={style.inputsContainer}>
						<FluidDatePicker
							onChange={handleChange}
							name={"startDate"}
							label={"Start Date (optional)"}
							value={values.startDate}
						/>
						<FluidDatePicker
							onChange={handleChange}
							name={"endDate"}
							label={"End Date (optional)"}
							value={values.endDate}
						/>
					</Box>
					<Spacer gap={32} />
					<FormControlLabel
						control={
							<Checkbox
								checked={values.create_ch51}
								onChange={(_, checked) => setFieldValue("create_ch51", checked)}
								name="create_ch51"
								color="primary"
							/>
						}
						label="Generate Chapter51 if applicable"
					/>
                    <FormControlLabel
						control={
							<Checkbox
								checked={values.fix_overlapping_horizons}
								onChange={(_, checked) => setFieldValue("fix_overlapping_horizons", checked)}
								name="fix_overlapping_horizons"
								color="primary"
							/>
						}
						label="Discontinue current Curtailment Objects in Period"
					/>
				</Modal>
			)}
		</Formik>
	);
};
